import React from 'react';
import { motion } from 'framer-motion';
import * as Icons from 'lucide-react';
import { whyChooseUs } from '../mock';

export const WhyChooseUs = () => {
  const getIcon = (iconName) => {
    const iconMap = {
      'users': Icons.Users,
      'rocket': Icons.Rocket,
      'lock': Icons.Lock,
      'trending-up': Icons.TrendingUp,
      'globe': Icons.Globe,
      'headphones': Icons.Headphones
    };
    return iconMap[iconName] || Icons.CheckCircle;
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -30 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <section className="py-24 bg-gradient-to-b from-white to-blue-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center space-y-4 mb-16"
        >
          <span className="inline-block px-4 py-2 bg-[#2196F3]/10 text-[#2196F3] rounded-full text-sm font-semibold">
            Why Choose Us
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#071B4D]">
            Your Trusted Technology Partner
          </h2>
          <p className="max-w-3xl mx-auto text-lg text-gray-600">
            Experience excellence in every project with our commitment to innovation,
            quality, and client success.
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {whyChooseUs.map((item) => {
            const IconComponent = getIcon(item.icon);
            return (
              <motion.div
                key={item.id}
                variants={itemVariants}
                whileHover={{ scale: 1.05 }}
                className="group p-6 bg-white/80 backdrop-blur-sm rounded-xl border border-gray-200 hover:border-[#2196F3] transition-all duration-300 shadow-md hover:shadow-xl"
              >
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-[#2196F3]/10 rounded-lg flex items-center justify-center group-hover:bg-[#2196F3] transition-colors duration-300">
                    <IconComponent className="w-6 h-6 text-[#2196F3] group-hover:text-white transition-colors duration-300" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-[#071B4D] mb-2">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 text-sm">
                      {item.description}
                    </p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};